import { render } from "./ProjectModal.vue?vue&type=template&id=f05b2598&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=f05b2598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05b2598"]])

export default __exports__